import {NgClass, SlicePipe} from '@angular/common';
import {Component, effect, inject, input, signal} from '@angular/core';
import {Router} from '@angular/router';
import {AggregatedDeviceStateStore} from 'src/app/domain/devices/aggregated-state/aggregated-device-state.store';
import {rssiString} from 'src/app/domain/devices/device-in-range';
import {DeviceInRangeStore} from 'src/app/domain/devices/device-in-range.store';
import {DeviceStore} from 'src/app/domain/devices/device.store';
import {Device} from 'src/app/infrastructure/moovement-api/models/asset';
import {statusColor} from 'src/app/domain/assets/status/status';
import {timeAgo} from 'src/app/domain/util/timestamps/timestamps';
import {Destination} from 'src/app/presentation/main-view/information-center/animals/add-animal/add-animal.component';
import {DeviceType} from 'src/app/domain/devices/device';
import {UserStore} from 'src/app/domain/user/user.store';

@Component({
  selector: 'app-unassigned-tag-button',
  imports: [
    NgClass,
    SlicePipe
  ],
  templateUrl: './unassigned-tag-button.component.html',
  styleUrl: './unassigned-tag-button.component.css'
})
export class UnassignedTagButtonComponent {

  id = input.required<string>();

  device = signal<Device | undefined>(undefined);

  showGpsData = signal(false);
  showBleData = signal(false);

  lastSeenBySatellite = signal<Date | undefined>(undefined);
  lastSeenByGateway = signal<Date | undefined>(undefined);
  lastSeenByBLEScanner = signal<Date | undefined>(undefined);

  lastSeenBySatelliteMessageColorClass = signal(statusColor());
  lastSeenBySatelliteMessage = signal('?');
  lastSeenByLoRaGatewayColorClass = signal(statusColor());
  lastSeenByLoRaGatewayMessage = signal('?');
  lastSeenByBLEScannerMessage = signal('?');
  lastSeenByBLEScannerMessageColorClass = signal(statusColor());

  rssi = signal('?');

  userStore = inject(UserStore);

  private aggregatedDeviceStateStore = inject(AggregatedDeviceStateStore);
  private deviceStore = inject(DeviceStore);
  private deviceInRangeStore = inject(DeviceInRangeStore);
  private router = inject(Router);

  constructor() {
    effect(() => {
      const device = this.deviceStore.entityMap()[this.id()];
      this.device.set(device);
    });

    effect(() => {
      const aggregatedDeviceState = this.aggregatedDeviceStateStore.entityMap()[this.id()];
      if (!aggregatedDeviceState) return;

      this.lastSeenBySatelliteMessage.set(timeAgo(aggregatedDeviceState.lastGPSFixAt, ''));
      this.lastSeenBySatelliteMessageColorClass.set(statusColor(aggregatedDeviceState.lastGPSFixAt));

      this.lastSeenByBLEScannerMessage.set(timeAgo(aggregatedDeviceState.lastSeenByBLEScannerAt, ''));
      this.lastSeenByBLEScannerMessageColorClass.set(statusColor(aggregatedDeviceState.lastSeenByBLEScannerAt));

      this.lastSeenByLoRaGatewayMessage.set(timeAgo(aggregatedDeviceState.lastSeenByGatewayAt, ''));
      this.lastSeenByLoRaGatewayColorClass.set(statusColor(aggregatedDeviceState.lastSeenByGatewayAt));
    });

    effect(() => {
      const deviceInRange = this.deviceInRangeStore.devicesInRange().get(this.id());
      this.rssi.set(rssiString(deviceInRange));
    });

    effect(() => {
      const deviceId = this.id();
      if (!deviceId) return;

      const deviceType = this.deviceStore.deviceIdToType().get(deviceId);
      if (!deviceType) return;

      if (deviceType == DeviceType.GPS_PROXIMITY_ACCELEROMETER_TAG) {
        this.showGpsData.set(true);
        this.showBleData.set(true);
      } else if (deviceType == DeviceType.GPS_TAG) {
        this.showGpsData.set(true);
        this.showBleData.set(false);
      } else if (deviceType === DeviceType.PROXIMITY_TAG) {
        this.showGpsData.set(false);
        this.showBleData.set(true);
      }
    });
  }

  onboard() {
    if (!this.userStore.canEdit()) return;

    const device = this.device();
    if (!device) return;

    this.router.navigate(
      ['/main/add-animal'],
      { queryParams: { hardwareId: device.hardwareId, destination: Destination.UNASSIGNED_TAGS } }
    );
  }
}
